import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Clientes from "@/pages/Clientes";
import Bancos from "@/pages/Bancos";
import Emitente from "@/pages/Emitente";
import Boletos from "@/pages/Boletos";
import PixRecebidos from "@/pages/PixRecebidos";
import Webhooks from "@/pages/Webhooks";
import Logs from "@/pages/Logs";
import Regua from "@/pages/Regua";
import CNAB from "@/pages/CNAB";
import Documentacao from "@/pages/Documentacao";
import Administracao from "@/pages/Administracao";
import { Toaster } from "sonner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div
        className="min-h-screen grid place-content-center text-sm text-zinc-500"
        data-testid="loading-screen"
      >
        Carregando…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <Login />
                </PublicOnly>
              }
            />
            <Route
              path="/register"
              element={
                <PublicOnly>
                  <Register />
                </PublicOnly>
              }
            />
            <Route
              path="/"
              element={
                <Protected>
                  <AppShell />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="boletos" element={<Boletos />} />
              <Route path="pix-recebidos" element={<PixRecebidos />} />
              <Route path="clientes" element={<Clientes />} />
              <Route path="bancos" element={<Bancos />} />
              <Route path="emitente" element={<Emitente />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="regua" element={<Regua />} />
              <Route path="cnab" element={<CNAB />} />
              <Route path="documentacao" element={<Documentacao />} />
              <Route path="administracao" element={<Administracao />} />
              <Route path="logs" element={<Logs />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
